import React from "react";
import { Pencil } from "./icons/Pencil";

export const ModalLabel = ({ label, setLabel }) => {
  return (
    <div className="modal-label">
      <Pencil fill="var(--purplish)" />
      <input
        id="label"
        placeholder="Enter alarm label"
        type="text"
        value={label}
        onChange={({ target }) => setLabel(target.value)}
      />
    </div>
  );
};
